import axios from 'axios';

const defaultBase = (() => {
  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost') {
      return 'http://localhost:4041';
    }
    return `${window.location.origin}/api`;
  }
  return 'http://localhost:4041';
})();

const API_BASE =
  (process.env.REACT_APP_API_BASE || defaultBase).replace(/\/$/, '');

const API_URL = `${API_BASE}/meetings`;

class DataService {
  async getMeetings() {
    const res = await axios.get(API_URL);
    const payload = res.data;

    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.meetings)) return payload.meetings;

    return [];
  }
}

export { API_BASE };
export default new DataService();
